import { render, staticRenderFns } from "./RecentlyAddedItems.vue?vue&type=template&id=f7da7718&"
import script from "./RecentlyAddedItems.vue?vue&type=script&lang=js&"
export * from "./RecentlyAddedItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports